// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"38a54886","513":"1d2a4472","703":"409f910e","787":"aadca95f"}[chunkId] + ".chunk.js";
};